import { Component, OnInit, Input } from '@angular/core';

import { LoadingType } from './../model/loader-type.model';
@Component({
  selector: 'monorepo-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnInit {
  @Input()
  loaderType: LoadingType = LoadingType.SPINNER;
  LoadingTypeEnum: any = LoadingType;

  constructor() {}

  ngOnInit() {}
}
